import fetch from './fetch'

class EvaluateApi {
	public getEvaluate(params: any) {
		return fetch({
			url: 'evaluate/token/detail',
			params,
		})
	}

	public saveEvaluate(form: any) {
		return fetch({
			url: 'evaluate/token/save',
			method: 'post',
			data: form,
		})
	}
}

export default new EvaluateApi()
